import { FC, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { hintsData } from '@/components/Hints/hintsData';
import { axios } from '@/axios';
import { config } from '@/config';
import { newUid } from '@/util';

const ResetHints = ({ hints, setHints, authUser, setNewPage }) => {
  const handleHints = async () => {
    const allHits = hintsData?.length;
    const updatedHintFlags = hints?.allHints?.map((value, index) => {
      if (index < allHits && value === '0') {
        return '1';
      }
      return value;
    });

    const promises = [];
    promises.push(
      axios.put(`${config.backend}/user/${authUser?.id}`, {
        hintFlags: updatedHintFlags?.join(''),
        id: authUser?.id,
      })
    );
    await Promise.allSettled(promises).then(() => {
      setHints((prev) => ({
        ...prev,
        id: null,
        active: null,
        allHints: updatedHintFlags,
        pageHints: [],
      }));
      setNewPage(newUid(20));
    });
  };

  useEffect(() => {
    if (hints) {
      const hintTimer = authUser?.hintTimer;
      const hintDate = new Date(hintTimer);
      const now = new Date();
      const diffInMs = now - hintDate;
      const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

      if (diffInMs > THIRTY_DAYS_MS) {
        handleHints();
      }
    }
  }, [authUser?.id]);
  return null;
};

export default ResetHints;
